export enum StatusLabel {
  ACTIVE = 'AKTIF',
  IN_ACTIVE = 'TIDAK AKTIF',
}
